import { EyeIcon } from './EyeIcon';

/**
 * author: Google
 * id 3C2B7DF3-97FE-4EC4-B6A9-69A75FB26B67
 * name eye
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye.svg
 * tags
 */
export const ShowIcon = EyeIcon;
export default ShowIcon